export enum FSMPlan {
  NO_PLAN = 'NO_PLAN',
  FSM_LITE = 'LITE_PLAN',
  FSM_PLUS = 'PAID_PLAN'
}

export enum FSMPlanStatus {
  ACTIVE = 'ACTIVE',
  TRIAL = 'TRIAL',
  INACTIVE = 'INACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELLED',
  PAUSED = 'PAUSED',
  RENEWED = 'RENEWED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  SYSTEM_DOWNGRADE = 'SYSTEM_DOWNGRADE',
  TRIAL_ENDED = 'TRIAL_ENDED',
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED'
}

export enum MANAGE_FSM_PLAN_BUTTON {
  NEXT = 'Next',
  RESUME_SUBSCRIPTION = 'Resume subscription'
}

export const FSM_ACTIVE_PLAN_STATES = [FSMPlan.FSM_PLUS];
